/**
 * Helper function that extracts the grid load
 * properties from a load summary.
 * @param {object} load - Load summary object
 * @return {object} - LoadSummary object
 */
const getLoadFromSummary = ({
  loadId,
  customerName,
  carrierName,
  carrierRepName,
  originCity,
  originState,
  destinationCity,
  destinationState,
  tlStatus,
  ltlStatus,
  visibilityAppName,
  visibilityAppStatus,
  problems,
  originPickupDate,
  destinationDropOffDate,
  lastHumanTrackDate,
  numberOfStops,
}) => ({
  loadId,
  customerName,
  carrierName,
  carrierRepName,
  originCity,
  originState,
  destinationCity,
  destinationState,
  tlStatus,
  ltlStatus,
  visibilityAppName,
  visibilityAppStatus,
  problems,
  originPickupDate,
  destinationDropOffDate,
  lastHumanTrackDate,
  numberOfStops,
});

export default getLoadFromSummary;
